module.exports = __webpack_public_path__ + "media/src/application/media/logo-brown-e8156c39d6ce9ee8ce994d656c5906d9.svg";